export const WEB_VERSION = '0.5.1';
